import {useState} from "react";

// Components

// Images
import chevronDown from '../assets/img/partnerPortal/welcomePage/chevron-down.png';
// Scss
// import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerPortal/welcome.scss';

import News from "../models/common/News";
import NewsRow from "./NewsRow";
import ButtonOne from "./ButtonOne";
import ContactRow from "./ContactRow";
import Contact from "../models/common/Contact";
import ItemRow from "./ItemRow";
import Item from "../models/common/Item";


function ItemSection(props) {


  const [itemList] = useState<Array<Item>>(props.itemList);


  function addItemList() {
    return itemList.map(i => <ItemRow title={i.title} buttonName={i.buttonName} link={i.buttonLink} />);
  }

  return (
    <>  
        <div className="infoListSection mt-3">
            {addItemList()}         
        </div>
            
    </>
  );


}

export default ItemSection;

